'use strict'

export default function ($stateProvider, $urlRouterProvider) {
  'ngInject'

  $urlRouterProvider.when('/keyboard', '/keyboard/list')
  $stateProvider
    .state('keyboard', {
      url: '/keyboard',
      template: require('./keyboard.html'),
      authenticate: true
    })
    .state('keyboard.list', {
      url: '/list',
      template: require('./list/list.html'),
      controller: 'KeyboardListController',
      controllerAs: 'kbListCtrl'
    })
    .state('keyboard.edit', {
      url: '/edit/:id',
      template: require('./edit/edit.html'),
      controller: 'KeyboardEditController',
      controllerAs: 'kbEdittCtrl'
    })
    .state('keyboard.add', {
      url: '/add',
      template: require('./add/add.html'),
      controller: 'KeyboardAddController',
      controllerAs: 'kbAddCtrl'
    })
}



// WEBPACK FOOTER //
// ./client/app/keyboard/keyboard.routes.js